import type { ProfileCertificationDto } from './profile.certification.dto';

export function sortProfileCertificationsByCreatedAt(
	certifications: ProfileCertificationDto[]
): ProfileCertificationDto[] {
	return [...certifications].sort((a, b) => {
		const aTime = a.createdAt ? Date.parse(a.createdAt) : Number.NaN;
		const bTime = b.createdAt ? Date.parse(b.createdAt) : Number.NaN;

		if (!Number.isNaN(aTime) && !Number.isNaN(bTime)) {
			return aTime - bTime;
		}

		return (a.profileCertificationId ?? 0) - (b.profileCertificationId ?? 0);
	});
}
